export const userAnalyticRequest = {
  USERS_ANALYTIC: "/analytics/users",
  USERS_SUMMARY: "/analytics/summary",
  DOWNLOAD_HISTORY: "/analytics/download-summary",
  SINGLE_PURCHASES: "/analytics/single-purchases",
};

export const subscriptionPlanRequest = {
  SUBSCRIPTION_PLAN: "/subscription/plans?country=ngn",
  SUBSCRIPTION_PLAN_USD: "/subscription/plans?country=usd",
  UPGRADE_USER: "/subscription/upgrade-user",
};

export const authRequest = {
  USER: "/users",
  LOGIN: "/users/login",
  LOGOUT: "/users/logout",
  ME: "/users/me",
  UPLOAD_IMAGE: "/images",
  VERIFY_USER_TOKEN: "/verify",
  RESEND_TOKEN: "verify/resend",
  UPDATE_PASSWORD: "user/password",
  SEND_VERIFICATION_CODE: "/users/sendcode",
};

export const scriptsRequest = {
  SCRIPTS: "/scripts",
  SCRIPTS_VERIFY: "/scripts/verify/:id",
  SCRIPTS_ADMIN: "/scripts/admin",
  SCRIPT: "/scripts/admin/:id",
  EDIT_SCRIPT: "scripts/admin/edit/:id",
  UPDATE_SCRIPT_MEDIA: "/scripts/admin/updatemedia/:slug",
  MY_SCRIPTS: "/scripts/user",
  VIEW_DOCUMENT: "/scripts/view/document/:id",
  DOWNLOAD_FILE: "/scripts/download/file/:id",
  SEARCH: "/scripts/search",
  CURRENT_USER_INFO_FOR_SCRIPT: "/scripts/user/:scriptId",
  EDIT_REQUESTS: "/scripts/admin/edit-requests",
  EDIT_REQUEST_DETAIL: "/scripts/admin/edit-requests/:id",
  APPROVE_EDIT_REQUEST: "/scripts/admin/edit-requests/:id/approve",
  DISCARD_EDIT_REQUEST: "/scripts/admin/edit-requests/:id/discard",
};

export const languageRequest = {
  LANGUAGES: "/languages",
  LANGUAGE: "/languages/:id",
};

export const categoryRequest = {
  CATEGORIES: "/categories",
  CATEGORY: "/categories/:id",
  MIGRATE: "/categories/migrate",
};

export const ratingRequest = {
  RATE_SCRIPT: "/scripts/:id/ratings",
};
export const commentsRequest = {
  ADD_COMMENT: "/scripts/:id/comments",
  COMMENT_ID: "/comments/:id",
  COMMENT_LIKE_ID: "/comments/like/:id",
  COMMENT_SPAM_ID: "/comments/spam/:id",
  SCRIPT_COMMENTS: "/scripts/:id/comments",
};
export const favoriteRequest = {
  FAVOURITE_ID: "/favourite/:id",
  GET_FAVOURITE: "",
};
export const followRequest = {
  FOLLOW_ID: "/follow/:id",
};
export const composersRequest = {
  COMPOSER: "/composer",
};
